export default __webpack_public_path__ + "static/media/star-color.1d8679f3.svg";